import React from 'react';
import './Statistics.css';

const Statistics: React.FC = () => {
  const stats = [
    { number: '15000+', label: 'Happy Students', icon: '👶' },
    { number: '10+', label: 'Expert Teachers', icon: '👨‍🏫' },
    { number: '17+', label: 'Years Experience', icon: '📅' },
    { number: '98%', label: 'Satisfaction Rate', icon: '⭐' }
  ];

  return (
    <section className="statistics">
      <div className="statistics-overlay">
        <div className="container">
          <h2 className="section-title">Kiddos Rainbows</h2>
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
